module.exports = __webpack_public_path__ + "img/the_eight_grand_lisboa.ecd18528.jpg";